var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0598 11.62C13.9983 11.62 15.5698 10.0485 15.5698 8.10998C15.5698 6.17146 13.9983 4.59998 12.0598 4.59998C10.1213 4.59998 8.5498 6.17146 8.5498 8.10998C8.5498 10.0485 10.1213 11.62 12.0598 11.62Z",
    fill: "#CC5C08",
    stroke: "#CC5C08",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.51 20.4C19.17 20.4 19.68 19.76 19.47 19.12C18.46 15.99 15.53 13.72 12.06 13.72C8.59005 13.72 5.66005 15.99 4.65005 19.12C4.45005 19.75 4.95005 20.4 5.61005 20.4H18.51Z",
    fill: "#CC5C08",
    stroke: "#CC5C08",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.6c737e17bae7e76cf025927864634793.svg";
export { ForwardRef as ReactComponent };